import { ProtocolIcon } from './chunk-ORESOXJH.js';
import { LAYERZERO_V2, LAYERZERO_V2_COMPONENTS, LAYERZERO_V2_EVENTS, pickField, LAYERZERO_V2_FIELDS, LAYERZERO_V2_LABELS, ProtocolValue, SectionCard, FactGrid, ProtocolParamList, ProtocolBadge } from './chunk-QB6P62A2.js';
import { BadgeCheck } from 'lucide-react';
import { jsx, jsxs } from 'react/jsx-runtime';

var QUORUM_CHIP = "inline-flex items-center gap-1 rounded-full border border-border/60 bg-muted/40 px-2 py-0.5 text-2xs font-medium";
function LayerZeroPayloadVerified({
  event,
  hint,
  chain,
  renderAddress
}) {
  const pid = hint.protocolId ?? LAYERZERO_V2.protocolId;
  const dvn = pickField(event.params, LAYERZERO_V2_FIELDS.dvn);
  const confirmations = pickField(event.params, LAYERZERO_V2_FIELDS.confirmations);
  const proofHash = pickField(event.params, LAYERZERO_V2_FIELDS.proofHash);
  const address = (v) => typeof v === "string" && renderAddress ? renderAddress(v, { chain }) : /* @__PURE__ */ jsx(ProtocolValue, { value: v });
  const facts = [
    { label: LAYERZERO_V2_LABELS.verifier, value: address(dvn), when: dvn },
    // The emitter is the ReceiveUln library that recorded the attestation —
    // a per-chain deployment, which is why this protocol is claimed by topic
    // rather than by address.
    { label: LAYERZERO_V2_LABELS.library, value: address(event.address), when: event.address },
    {
      label: LAYERZERO_V2_LABELS.confirmations,
      value: /* @__PURE__ */ jsx(ProtocolValue, { value: confirmations }),
      when: confirmations != null
    },
    { label: LAYERZERO_V2_LABELS.proofHash, value: /* @__PURE__ */ jsx(ProtocolValue, { value: proofHash }), when: proofHash }
  ];
  return /* @__PURE__ */ jsxs(
    SectionCard,
    {
      title: /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(ProtocolIcon, { protocolId: pid, icon: BadgeCheck }),
        /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold", children: hint.label ?? "LayerZero payload verified" })
      ] }),
      protocolId: pid,
      meta: /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(
          "span",
          {
            className: QUORUM_CHIP,
            title: "A message is delivered once a QUORUM of verifiers has attested. This is one of them \u2014 not a delivery.",
            children: LAYERZERO_V2_LABELS.oneOfQuorum
          }
        ),
        /* @__PURE__ */ jsx(ProtocolBadge, { protocolId: pid })
      ] }),
      children: [
        /* @__PURE__ */ jsx(FactGrid, { facts }),
        /* @__PURE__ */ jsxs("details", { className: "mt-3 min-w-0", children: [
          /* @__PURE__ */ jsx("summary", { className: "cursor-pointer text-xs text-muted-foreground hover:text-foreground", children: "All event fields" }),
          /* @__PURE__ */ jsx("div", { className: "pt-2", children: /* @__PURE__ */ jsx(ProtocolParamList, { params: event.params, emptyLabel: "No decoded fields" }) })
        ] })
      ]
    }
  );
}

// src/protocols/layerzero_v2/index.ts
var PID = LAYERZERO_V2.protocolId;
var C = LAYERZERO_V2_COMPONENTS;
var LAYERZERO_V2_HINTS = {
  valueHints: [],
  callHints: [],
  eventHints: [
    {
      protocolId: PID,
      event: LAYERZERO_V2_EVENTS.payloadVerified,
      component: C.payloadVerified,
      summaryFields: []
    }
  ]
};
function registerLayerZeroV2(registry) {
  registry.registerEvent(C.payloadVerified, LayerZeroPayloadVerified);
  registry.registerHints(LAYERZERO_V2_HINTS);
  return registry;
}

export { LAYERZERO_V2_HINTS, LayerZeroPayloadVerified, registerLayerZeroV2 };
//# sourceMappingURL=chunk-6X7IJL36.js.map
//# sourceMappingURL=chunk-6X7IJL36.js.map